module.exports = __webpack_public_path__ + "img/order-process-image-04.3c0a64d.svg";